import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import AlertForm from "./AlertForm";
import AlertRulesTable from "./AlertRulesTable";

const EMPTY_FORM = {
  name: "", description: "", scope: "all", destination_ids: [],
  threshold_pct: 90, window_minutes: 60, min_samples: 5,
  notify_email: "", notify_slack_webhook: "",
  cooldown_minutes: 30, is_active: true,
};

/**
 * "Auto-alerts" panel below the destinations table on /delivery-health.
 * Owns the form state; parent supplies rows + reload/delete/evaluate.
 */
export default function AlertRulesSection({
  alerts, rows, showForm, setShowForm, onReload, onDelete, onEvaluate,
}) {
  const [form, setForm] = useState(EMPTY_FORM);

  const submit = async (e) => {
    e.preventDefault();
    // `scope` is UI-only; server takes the resolved destination_ids array
    // ("*" for all-active, otherwise the picked list).
    const body = {
      ...form,
      destination_ids: form.scope === "all" ? ["*"] : form.destination_ids,
    };
    delete body.scope;
    try {
      await api.post("/delivery/health-alerts", body);
      toast.success("Alert rule created");
      setShowForm(false);
      setForm(EMPTY_FORM);
      onReload();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    }
  };

  return (
    <div className="mt-8">
      <div className="flex items-end justify-between mb-3">
        <div>
          <div className="label-mono">Auto-alerts</div>
          <h2 className="font-chivo font-black text-2xl uppercase tracking-tighter">
            Success-rate alert rules
          </h2>
          <div className="text-xs text-zinc-600 max-w-2xl mt-0.5">
            Get pinged on Slack/email when a destination&#39;s success rate drops below a threshold.
            Evaluated every 60 seconds by the scheduler.
          </div>
        </div>
        <button onClick={() => setShowForm((v) => !v)} data-testid="alert-new-btn"
          className="border border-black bg-black text-white px-3 py-2 text-xs uppercase tracking-widest">
          + New rule
        </button>
      </div>

      {showForm && <AlertForm form={form} setForm={setForm} rows={rows} onSubmit={submit} />}
      <AlertRulesTable alerts={alerts} onEvaluate={onEvaluate} onDelete={onDelete} />
    </div>
  );
}
